import type { TranslationProvider } from '@ports/TranslationProvider.ts';
import { GoogleTranslationProvider, type GoogleTranslationProviderOptions } from './GoogleTranslationProvider.ts';
import {
  MemberTranslationProvider,
  type MemberTranslationEngine,
  type MemberTranslationProviderOptions,
} from './MemberTranslationProvider.ts';

export type ResolveTranslationProviderInput = {
  engine: string;
  unlock: boolean;
  userId: string;
  userToken: string;
  google?: GoogleTranslationProviderOptions;
  member?: Omit<MemberTranslationProviderOptions, 'engine' | 'userId' | 'userToken'>;
};

/** Pick a TranslationProvider for the current engine + membership. */
export function resolveTranslationProvider(
  input: ResolveTranslationProviderInput,
): TranslationProvider {
  if (input.engine === 'google' || !input.engine) {
    return new GoogleTranslationProvider(input.google);
  }
  if (input.engine === 'azure' || input.engine === 'deepl' || input.engine === 'ai') {
    return new MemberTranslationProvider({
      engine: input.engine as MemberTranslationEngine,
      userId: input.userId,
      userToken: input.userToken,
      ...input.member,
    });
  }
  // Unknown engine → free google fallback
  return new GoogleTranslationProvider(input.google);
}

export { GoogleTranslationProvider, MemberTranslationProvider };
